import type { SerializedError } from "@reduxjs/toolkit";

import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import initialConfig from "../initialConfig";

const initialState = {
  getUserPaymentData: {},
  getUserPaymentLoading: false,
  getUserPaymentError: null as null | SerializedError,
};

interface IGetUserPayment {
  accessToken: string;
}

export const getUserPaymentFunc = createAsyncThunk("getUserPayment/getUserPaymentFunc", async (values: IGetUserPayment) => {
  const data1 = JSON.stringify({
    query: `query Self_user {
      self_user {
        billingInfo {
          billingAddress {
            postcode
          }
        }
      }
    }`
  });
  
  const config = initialConfig('https://api.hophop.com.tr/payment/graphql', data1, values.accessToken);

  const response = axios(config).then((res) => {
    const data = res.data;
    return data;
  }).catch((err) => err);

  const data = await response;
  return data;
});


const getUserPayment = createSlice({
  name: "getUserPayment",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserPaymentFunc.pending, (state) => {
      state.getUserPaymentLoading = true;
    });
    builder.addCase(getUserPaymentFunc.fulfilled, (state, action) => {
      state.getUserPaymentLoading = false;
      state.getUserPaymentData = action.payload?.data?.self_user;
      state.getUserPaymentError = action.payload.errors || action.payload?.response?.status;
    });
    builder.addCase(getUserPaymentFunc.rejected, (state, action) => {
      state.getUserPaymentLoading = false;
      state.getUserPaymentError = action.error;
    });
  }
});

export default getUserPayment.reducer;